import { useMutation, useQueryClient } from "react-query";
import { useSnackbar } from "notistack";

import { ReferralType } from "../../models";
import { RQ } from "../../globals/enums";
import { patch } from "../../api/generic-api";
import { patchEntity } from "../../utils";

export const usePatchReferralType = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation(
    (referralType: Partial<ReferralType>) =>
      patch({
        route: "referral-types",
        id: referralType.id ?? "",
        entity: referralType,
      }),
    {
      onSuccess: (referralType) => {
        enqueueSnackbar("Referral Type Updated", { variant: "success" });
        queryClient.setQueryData(
          RQ.REFERRAL_TYPES,
          (referralTypes: ReferralType[] | undefined) =>
            !referralTypes
              ? []
              : patchEntity<ReferralType>(referralTypes, referralType, "id")
        );
      },
      onError: () => {
        enqueueSnackbar("Referral Type Updating Error", { variant: "error" });
      },
    }
  );
};
